import React from 'react';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { RadioChipOption } from '@applicationKYC/FarmersQuestionnaire/components';
import { useFarmerFormValidation } from '@applicationKYC/LegalEntityQuestionnaire/validation/useFarmerFormValidation';
import { useTranslation } from 'react-i18next';
import { Field, Input, Loader } from '@single-platform/components';
import {
  FarmersQuestionnaireHeader,
  PageSubtitle
} from '@applicationKYC/FarmersQuestionnaire/farmersQuestionnaire.style';
import useWindowDimensions from '@applicationKYC/LegalEntityQuestionnaire/Utils/window-size.service';
import breakpointSizes from '@applicationKYC/LegalEntityQuestionnaire/styled-theme-styles/global-style-variables.style';
import {
  FormStyles,
  PageHeader
} from '@applicationKYC/LegalEntityQuestionnaire/screens/renderPage/renderPage.style';
import { ButtonSectionWrapperStyle } from '@applicationKYC/FarmersQuestionnaire/questionnaireSections/formStyles';
import { ButtonSection } from '@applicationKYC/LegalEntityQuestionnaire/components';
import { yesNoChipOptions } from '@applicationKYC/FarmersQuestionnaire/constants';
import { selectKycAppState } from '@redux';

const defaultValues = {
  doesFarmHaveWebsite: null,
  website: null
};

export const FarmWebsitePage = ({ onSubmit, isAtBottom }) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const { loading, farmerInformation } = useSelector((state) => state.FarmersQuestionnaireReducer);
  const applicationState = useSelector(selectKycAppState);

  const validationSchema = Yup.object({
    doesFarmHaveWebsite: Yup.boolean().required(t('validation_required_field')).nullable(),
    website: Yup.string().when('doesFarmHaveWebsite', {
      is: true,
      then: Yup.string().required(t('validation_required_field')).nullable(),
      otherwise: Yup.string().notRequired().nullable()
    })
  });

  const existingValues = farmerInformation?.farmActivitiesSection?.farmWebsitePage;
  const initialValues = { ...defaultValues, ...existingValues };

  const { validationHelpers, getValues, setTouchedOnAll, handleSubmit } = useFarmerFormValidation({
    initialValues,
    validationSchema
  });

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    await handleSubmit(
      async (data) => {
        if (data.doesFarmHaveWebsite === false) {
          data.website = null;
        }

        await onSubmit?.(data, 'farmWebsitePage');
      },
      () => setTouchedOnAll()
    )();
  };

  const values = getValues();

  if (loading) return <Loader />;

  return (
    <FormStyles small={width < breakpointSizes.phone}>
      <FarmersQuestionnaireHeader>
        <PageHeader>{t('farmers_website_page_header')}</PageHeader>
        <PageSubtitle>{t('farmers_website_page_subtitle')}</PageSubtitle>
      </FarmersQuestionnaireHeader>
      <Field
        Component={RadioChipOption}
        options={yesNoChipOptions}
        value={values.doesFarmHaveWebsite}
        name="doesFarmHaveWebsite"
        validationHelpers={validationHelpers}
        validateOnChange
        disabled={applicationState?.state === 'UserFillingApplication' ? false : true}
      />
      {values.doesFarmHaveWebsite && (
        <Field
          Component={Input}
          name="website"
          value={values.website}
          placeholder={t('farmers_website_name')}
          validationHelpers={validationHelpers}
          validateOnChange
          required
          disabled={applicationState?.state === 'UserFillingApplication' ? false : true}
        />
      )}
      <ButtonSectionWrapperStyle isAtBottom={isAtBottom}>
        <ButtonSection
          secondButtonClick={onHandleSubmit}
          secondButtonPrimary
          secondButtonText={
            applicationState?.state === 'UserFillingApplication'
              ? t('button_save_and_continue')
              : t('button_continue')
          }
        />
      </ButtonSectionWrapperStyle>
    </FormStyles>
  );
};
